import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, AppText, Button, Row, styled } from '@streem/ui-react';
import { ANALYTICS_DATA_ATTRIBUTE } from '@streem/analytics';
export function WideButton(props) {
    const dataAttrs = {};
    if (props[ANALYTICS_DATA_ATTRIBUTE] !== undefined) {
        dataAttrs[ANALYTICS_DATA_ATTRIBUTE] = props[ANALYTICS_DATA_ATTRIBUTE];
    }
    return (_jsx(Row, { width: "75%", justifyContent: "center", children: _jsx(Button, { disabled: props.disabled, "data-testid": props.testid, borderRadius: "26px", height: "52px", width: "100%", maxWidth: "350px", onClick: props.onClick, ...dataAttrs, children: _jsxs(CenteredRow, { children: [props.icon && (_jsxs(Row, { mr: 3, justifyContent: "center", children: [_jsx(AppIcon, { name: props.icon, size: 'small', color: 'white' }), ' '] })), _jsx(AppText, { color: "light", headingFontFamily: true, style: { fontSize: '18px' }, children: props.children })] }) }) }));
}
const CenteredRow = styled(Row)({
    alignItems: 'center',
    justifyContent: 'center',
});
//# sourceMappingURL=wide_button.js.map